export default {"src":"/_next/static/media/calendarOne_40.3e98c173.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};